/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_DescriptionInputs */

const vi_product_description = /** @type {(inputs: Product_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả`)
};

/**

* @param {Product_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_description = /** @type {((inputs?: Product_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_description(inputs)
});